@if (
  {
    pendingOrgSwitch: pendingOrgSwitch$ | async,
    pendingOrgRegistration: pendingOrgRegistration$ | async,
  };
  as data
) {
  <div class="mat-app-background">
    @if (!routingState.isHideHeaderOnMobileRoute()) {
      <div class="header-wrapper">
        @let subtitle = initSubtitle();
        <claas-header
          class="main-navbar"
          [title]="'connect'"
          [isMenuOpen]="isExpanded"
          [showMenuIconButton]="!routingState.isHideHeaderRoute()"
          [subTitle]="subtitle ? (subtitle | translate) : undefined"
          (logoClicked)="handleLogoClick()"
          [logoInteractive]="true"
          [softwareStatusOverlay]="stage !== 'PROD' ? stage : undefined"
          (isMenuOpenChange)="getActionFromNavbar($event)">
          <ng-container ngProjectAs="content-mid">
            @if (!routingState.isHideHeaderRoute()) {
              <claas-application-switcher
                [applications]="applications"
                (click)="onApplicationSwitcherClick($event)"></claas-application-switcher>
            }
          </ng-container>

          <ng-container ngProjectAs="content-right">
            @if (!routingState.isHideHeaderRoute()) {
              <app-right-navbar></app-right-navbar>
            } @else if (routingState.showHelpMenu()) {
              <app-help-menu
                [currentUser]="currentUser() ?? null"
                [currentOrganisation]="currentOrganisation() ?? null"></app-help-menu>
            }
          </ng-container>
        </claas-header>
      </div>
    }
    <app-survey-wrapper />

    @if (!routingState.isHideSidenavRoute()) {
      <cde-sidenav
        [sideNavItems]="sideNavItems$$() ?? []"
        [orgRegistered]="orgRegistered()"
        [orgIsRejected]="orgIsRejected()"
        [(isExpanded)]="isExpanded"
        [pendingOrgSwitch]="data.pendingOrgSwitch"
        [pendingOrgRegistration]="data.pendingOrgRegistration"
        [rehydratePending]="rehydratePending$$()"
        [orgId]="orgId"
        [validatedOrg]="validatedOrg()"
        [internalOrg]="internalOrg()"
        (clickedEvent)="handleClickedEvent($event)">
      </cde-sidenav>
    } @else {
      <div class="feature-router-outlet-container">
        <router-outlet></router-outlet>
      </div>
    }
  </div>
  @if (orgChanging) {
    <div class="org-loading-backdrop">
      <span class="loading-msg" data-testid="change-organisation-message">{{
        'global.changing_organization' | translate
      }}</span>
    </div>
  }
}
